var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4987 3.33325H2.4987C1.57822 3.33325 0.832031 4.07944 0.832031 4.99992V14.9999C0.832031 15.9204 1.57822 16.6666 2.4987 16.6666H17.4987C18.4192 16.6666 19.1654 15.9204 19.1654 14.9999V4.99992C19.1654 4.07944 18.4192 3.33325 17.4987 3.33325Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.832031 8.33325H19.1654",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCards);
export default __webpack_public_path__ + "static/media/bank-cards.bb4fb2c1fed0202a6d2aeffbff2f10ce.svg";
export { ForwardRef as ReactComponent };